import { registerLocaleData } from "@angular/common";
import localeEs from "@angular/common/locales/es";
import localeUs from "@angular/common/locales/en";

export function localeFactory() {
  switch (navigator.language.toLowerCase()) {
    case "es":
    case "es-es":
      registerLocaleData(localeEs);
      return "es";
    default:
      registerLocaleData(localeUs);
      return "en-US";
  }
}
